import { TextField, TextFieldProps } from '@components/text-field';

import { FormFieldProps, FormValidatorType } from './types';
import { useFormField } from './use-form-field';

export type FormUrlFieldProps<T = unknown> = Omit<
  FormFieldProps<TextFieldProps, T>,
  'validators'
> & {
  validators?: Array<Exclude<FormValidatorType, 'valid-http-url'>>;
};

export function FormUrlField<T>(props: FormUrlFieldProps<T>) {
  const formFieldProps = useFormField({
    ...props,
    validators: ['url', ...(props.validators ?? [])],
  });

  return <TextField {...props} {...formFieldProps} />;
}
